import { useMediaQuery } from "react-responsive"
import parse from "html-react-parser";

const MainPeopleSection = (props) => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })
    const { title, itemArray } = props

    if (isMobile)
        return (
            <section className="flex w100 white-bkg">
                <section className="main-middle-section-mobile">
                    <h2 className="middle-section-title">{title}</h2>

                    <section className="flex jcenter wrap people-cards">
                        {
                            (itemArray.map((item, index) => {
                                return (
                                    <article key={index} className="person-card">
                                        <i className="bi bi-quote person-card-quote-icon"></i>
                                        <img loading="lazy" alt="Imagen" src={item.imageURL} className="person-card-image"></img>
                                        {parse(item.text)}
                                    </article>
                                )
                            }))
                        }
                    </section>

                </section>
            </section>
        )
    else
        return (
            <section className="flex col">
                <section className="main-middle-section-2">
                    <h2 className="middle-section-title ">{title}</h2>
                </section>
                <section className="flex jcenter main-middle-section-2 people-cards">
                    {
                        (itemArray.map((item, index) => {
                            return (
                                <article key={index} className="person-card">
                                    <i className="bi bi-quote person-card-quote-icon"></i>
                                    <img loading="lazy" alt="Imagen" src={item.imageURL} className="person-card-image"></img>
                                    {parse(item.text)}
                                </article>
                            )
                        }))
                    }
                </section>
            </section>
        )

}

export default MainPeopleSection